import React, { useState, useEffect } from "react";
import { supabase } from "../../supabaseClient.js";
import "../../styles/Ledger.css";

const Ledger = () => {
  const [workers, setWorkers] = useState([]);
  const [workerFilter, setWorkerFilter] = useState("ALL");
  const [completedLots, setCompletedLots] = useState([]);
  const [viewLot, setViewLot] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadWorkers();
    loadCompletedLots();
  }, []);

  const loadWorkers = async () => {
    const { data } = await supabase
      .from("WORKERS")
      .select("*")
      .eq("status", true);

    setWorkers(data || []);
  };

  const loadCompletedLots = async () => {
    setLoading(true);

    const { data, error } = await supabase
      .from("MASTER_RECEIVE")
      .select(`
        id,
        issue_id,
        receive_date,
        received_pcs,
        rejected_pcs,
        rate_per_pc,
        amount,
        MASTER_ISSUE (
          id,
          pcs,
          item_id,
          worker_id,
          ITEMS ( item_name ),
          WORKERS ( worker_name )
        )
      `)
      .order("receive_date", { ascending: false });

    if (!error) setCompletedLots(data || []);
    else console.log("SUPABASE ERROR:", error);

    setLoading(false);
  };

  const filteredList =
    workerFilter === "ALL"
      ? completedLots
      : completedLots.filter(
          (lot) =>
            lot?.MASTER_ISSUE?.WORKERS?.worker_name === workerFilter
        );

  const totalAmount = filteredList.reduce(
    (sum, lot) => sum + Number(lot.amount || 0),
    0
  );

  return (
    <div className="ledgerContainer">
      <div className="ledgerCard">
        <h2 className="ledgerTitle">📘 Master Ledger</h2>

        <div className="filterRow">
          <label>Filter by Worker:</label>

          <select
            value={workerFilter}
            onChange={(e) => setWorkerFilter(e.target.value)}
          >
            <option value="ALL">All Workers</option>
            {workers.map((w) => (
              <option key={w.id} value={w.worker_name}>
                {w.worker_name}
              </option>
            ))}
          </select>

          <button className="refreshBtn" onClick={loadCompletedLots}>
            Refresh
          </button>
        </div>

        <div className="tableWrap">
          <table className="ledgerTable">
            <thead>
              <tr>
                <th>Lot No</th>
                <th>Worker</th>
                <th>Item</th>
                <th>Issued</th>
                <th>Received</th>
                <th>Rejected</th>
                <th>Rate</th>
                <th>Amount</th>
                <th>Date</th>
                <th>View</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="10">Loading...</td>
                </tr>
              ) : filteredList.length === 0 ? (
                <tr>
                  <td colSpan="10">No completed lots</td>
                </tr>
              ) : (
                filteredList.map((lot) => (
                  <tr key={lot.id}>
                    <td>
                      #{lot.MASTER_ISSUE?.id
                        ?.slice(-6)
                        ?.toUpperCase()}
                    </td>

                    <td>{lot.MASTER_ISSUE?.WORKERS?.worker_name}</td>

                    <td>{lot.MASTER_ISSUE?.ITEMS?.item_name}</td>

                    <td>{lot.MASTER_ISSUE?.pcs}</td>

                    <td>{lot.received_pcs}</td>

                    <td>{lot.rejected_pcs}</td>

                    <td>{lot.rate_per_pc}</td>

                    <td>₹ {lot.amount}</td>

                    <td>
                      {new Date(lot.receive_date).toLocaleDateString()}
                    </td>

                    <td>
                      <button
                        className="viewBtn"
                        onClick={() => setViewLot(lot)}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))
              )}

              {filteredList.length > 0 && (
                <tr className="totalRow">
                  <td colSpan="7">TOTAL</td>
                  <td colSpan="3">₹ {totalAmount}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {viewLot && (
        <div
          className="popupOverlay"
          onClick={() => setViewLot(null)}
        >
          <div
            className="popupCard"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="closeBtn"
              onClick={() => setViewLot(null)}
            >
              ×
            </button>

            <h3 className="popupHeader">
              Lot #
              {viewLot.MASTER_ISSUE.id
                .slice(-6)
                .toUpperCase()}
            </h3>

            <div className="popupBody">
              <p>
                <b>Worker:</b>{" "}
                {viewLot.MASTER_ISSUE.WORKERS.worker_name}
              </p>
              <p>
                <b>Item:</b>{" "}
                {viewLot.MASTER_ISSUE.ITEMS.item_name}
              </p>

              <p>
                <b>Issued:</b> {viewLot.MASTER_ISSUE.pcs}
              </p>

              <p>
                <b>Received:</b> {viewLot.received_pcs}
              </p>

              <p>
                <b>Rejected:</b> {viewLot.rejected_pcs}
              </p>

              <p>
                <b>Rate:</b> ₹ {viewLot.rate_per_pc}
              </p>

              <p>
                <b>Amount:</b> ₹ {viewLot.amount}
              </p>

              <p>
                <b>Date:</b>{" "}
                {new Date(
                  viewLot.receive_date
                ).toLocaleDateString()}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Ledger;
